const handleConfirmation = (cb) => (e) => {
  if (e.key === 'Enter') {
    cb && cb();
  }
};

export default handleConfirmation;
